import { render } from "./ModalDefaultStyles.vue?vue&type=template&id=4d9a6da9&scoped=true"
import script from "./ModalDefaultStyles.vue?vue&type=script&lang=js"
export * from "./ModalDefaultStyles.vue?vue&type=script&lang=js"

import "./ModalDefaultStyles.vue?vue&type=style&index=0&id=4d9a6da9&lang=scss&scoped=true"

import exportComponent from "/admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d9a6da9"]])

export default __exports__